<template>
  <div class="home">
    <div class="content-wrapper">
      <div class="logo">
        <img class="logo__image" src="@/assets/logo.jpg" alt="DAV" />
      </div>
      <form class="login-form">
        <ul class="login-form__fields">
          <li>
            <label class="login-form__label"> Vorname </label> <br />
            <input type="text" v-model="name" /> <br />
          </li>
          <li>
            <label class="login-form__label"> Nachname</label> <br />
            <input type="text" v-model="surname" /><br />
          </li>
          <li>
            <label class="login-form__label"> Geburtstag </label> <br />
            <input v-mask="'##.##.####'" type="text" v-model="birthday" /><br />
          </li>
          <button
            v-promise-btn
            type="submit"
            class="button"
            @click.prevent="goToCard"
          >
            Los
          </button>
        </ul>
        <div class="error">
          {{ error }}
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import firebase from 'firebase/app';

export default {
  name: 'Home',
  title: 'Home',
  components: {},
  data() {
    return {
      name: '',
      surname: '',
      birthday: '',
      imageData: '',
      currentUser: '',
      error: '',
    };
  },

  methods: {
    async goToCard() {
      try {
        const getUserHash = firebase.functions().httpsCallable('getUserHash');

        const res = await getUserHash({
          name: this.name,
          surname: this.surname,
          birthday: this.birthday,
        });
        this.$router.push(res.data.data.hash);
      } catch (error) {
        this.error = 'Your data is incorrect';
      }
    },
  },
};
</script>

<style lang="scss" scoped>
/* Form Styles for all START */
input:focus,
select:focus,
textarea:focus,
button:focus {
  outline: none;
}
* {
  margin: 0;
  padding: 0;
  font-family: roboto;
}

::placeholder {
  color: rgba(114, 114, 114, 0.372);
}

input[type='text'],
input[type='text'] {
  width: 200px;
  padding-top: 5px;
  padding-bottom: 10px;
  border-width: 0 0 1px;
  border-bottom: 1px solid white;
  font-size: 16px;
  font-weight: 400;
  color: white;
  background-color: transparent;
  margin-bottom: 5px;
}



input:focus {
  border-color: white;
}

.error {
  color: red;
  text-align: center;
}

.button {
  /* remove default behavior */
  appearance: none;
  -webkit-appearance: none;
  /* usual styles */
  margin-top: 20px;
  padding: 13px;
  border: none;
  background-color: white;
  color: #747474;
  font-weight: 600;
  border-radius: 20px;
  width: 100%;
}

/* Form Styles for all END */
.home {
  display: flex;
  display: -webkit-flex;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
  height: 100vh;
  background-color: #7dc355;
  background-size: cover;
}

.logo {
  &__image {
    max-width: 200px;
  }
}

.login-form {
  width: 200px;
  margin-top: 1rem;
  border-radius: 4px;

  &__label {
    font-size: 12px;
    font-weight: 600;
  }

  &__fields {
    width: 200px;
    padding: 0;
    margin: 5px 0px;
    list-style-type: none;
  }
}
</style>
